import { ActionTypes } from "../constants/action-types";

/*
Add-to-cart Action Types with payload
*/
export const openCart = (click) => {
  return {
    type: ActionTypes.OPEN_STICKY_ADD_TO_CART,
    payload: click,
  };
};

export const closeCart = (click) => {
  return {
    type: ActionTypes.CLOSE_STICKY_ADD_TO_CART,
    payload: click,
  };
};

export const addToCart = (cartData) => {
  return {
    type: ActionTypes.ADD_TO_CART,
    payload: cartData,
  };
};

export const openMiniCart = (click) => {
  return {
    type: ActionTypes.OPEN_MINI_CART,
    payload: click,
  };
};

export const openQBMiniCart = (click) => {
  return {
    type: ActionTypes.OPEN_QB_MINI_CART,
    payload: click,
  };
};

export const updateCart = (cartData) => {
  return {
    type: ActionTypes.UPDATE_CART,
    payload: cartData,
  };
};

export const openEngraveSidebar = (click) => {
  return {
    type: ActionTypes.OPEN_ENGRAVE_SIDEBAR,
    payload: click,
  };
};